import { motion } from "framer-motion";

export const OverviewSection = () => {
  return (
    <section className="py-16 px-4 bg-background">
      <div className="max-w-3xl mx-auto text-center">
        <motion.p
          className="text-lg text-muted-foreground leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          While many agencies focus only on generating leads, we focus on what happens <span className="text-foreground font-semibold">after</span>. Our systems are built for businesses where conversion, follow-up, and booking rates directly impact revenue.
        </motion.p>
      </div>
    </section>
  );
};
